import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';

/** Plain-text system events. Stored line breaks remain part of the message;
 * content is never parsed as HTML or split by labels inside a user comment. */
export default function SystemMessage({ content, time, dateTime, ...events }) {
  const lines = String(content ?? '').replace(/\r\n?/g, '\n').split('\n');
  const titleIndex = lines.findIndex(line => line.trim());
  const hasDetails = lines.some((line, index) => index > titleIndex && line.trim());

  return (
    <Box
      component="article"
      aria-label="Системное сообщение"
      {...events}
      sx={(theme) => ({
        alignSelf: 'flex-start',
        mr: 'auto',
        minWidth: 0,
        width: 'fit-content',
        maxWidth: { xs: '100%', sm: 'min(720px, 90%)' },
        boxSizing: 'border-box',
        px: { xs: 1.5, sm: 1.75 },
        py: 1.25,
        borderRadius: '12px',
        borderTopLeftRadius: '4px',
        border: '1px solid',
        borderColor: theme.palette.mode === 'dark'
          ? 'rgba(185,166,255,.34)' : 'rgba(112,77,230,.22)',
        borderLeft: '3px solid',
        borderLeftColor: theme.palette.mode === 'dark' ? '#aa91ff' : '#8260ed',
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(130,96,237,.17)' : 'rgba(244,240,255,.96)',
        color: 'text.primary',
        textAlign: 'left',
      })}
    >
      <Box>
        {lines.map((line, index) => line.trim() ? (
          <Typography
            component="p"
            level="body-sm"
            key={index}
            sx={{
              m: 0,
              color: 'inherit',
              fontSize: 14,
              lineHeight: 1.55,
              fontWeight: hasDetails && index === titleIndex ? 600 : 400,
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              wordBreak: 'normal',
            }}
          >
            {line}
          </Typography>
        ) : <Box key={index} aria-hidden="true" sx={{ height: 8 }} />)}
      </Box>
      <Box sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 2, mt: 0.875, color: 'primary.plainColor',
      }}>
        <Typography
          component="span"
          level="body-xs"
          startDecorator={<AutoAwesomeRoundedIcon sx={{ fontSize: 13 }} />}
          sx={{ fontSize: 11, fontWeight: 700, lineHeight: '16px', color: 'inherit' }}
        >
          Система
        </Typography>
        {time && (
          <Typography
            component="time"
            dateTime={dateTime || undefined}
            level="body-xs"
            sx={{ color: 'text.secondary', fontSize: 11, lineHeight: '16px', flexShrink: 0 }}
          >
            {time}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
